import { ReactComponent as LockSvg } from '../../img/pms/lock.svg'
import styles from './Encrypted.module.scss'

const Encrypted = () => (
  <div className={styles.card}>
    <div className={styles.svgIcon}>
      <LockSvg />
    </div>
    <div className={styles.content}>
      <p className={styles.title}>
        Your data is encrypted and can’t be accessed by anyone, including us
      </p>
      <p className={styles.faded}>
        Credentials are uniquely encrypted and saved securely at highest standards.
      </p>
    </div>
  </div>
)

export default Encrypted
